import { useState } from "react";
import DOMPurify from 'dompurify';

export default function CaseActionGroup({ caseData, action, onPayTrigger, onExtensionTrigger, onScreeningTrigger, onHearingTrigger }) {
  const [showReviewActionButtons, setShowReviewActionButtons] = useState(false);
  let showPayButton = caseData.apt_validforpayment && action !== 'Pay Penalty';
  let showRequestExtensionButton = caseData.apt_validforextension && action !== 'Screening Extension Request';
  let showRequestScreeningButton = caseData.apt_validforscreening && action !== 'Screening Review Request';
  let showRequestHearingButton = caseData.apt_validforhearing && action !== 'Hearing Review Request';
  let showDisputeButton = showRequestExtensionButton || showRequestScreeningButton || showRequestHearingButton;

  return (
    <div className="button-group">
      {showPayButton && (
        <button
          className="full-width-button webform-button--submit button button--primary js-form-submit form-submit"
          onClick={() => { setShowReviewActionButtons(false); onPayTrigger(); }}
        >
          Pay Fine
        </button>
      )}
       {!showReviewActionButtons && showDisputeButton && (
      <button
        className="full-width-button webform-button--submit button button--primary js-form-submit form-submit"
        onClick={() => setShowReviewActionButtons(!showReviewActionButtons)}
      >
        Dispute Penalty
      </button>
       )}

      {showReviewActionButtons && (
      <div>
        {(showRequestExtensionButton || showRequestScreeningButton || showRequestHearingButton) && (
          <label>
          Dispute Actions
        </label>
        )}
      {showRequestScreeningButton && (
        <div className="button-with-description">
          <span className="button-description">
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(drupalSettings.apt_config.screening_description) }} />
          </span>
          <button
            className="full-width-button webform-button--submit button button--primary js-form-submit form-submit"
            onClick={onScreeningTrigger}
          >
            Request Screening Review
          </button>
        </div>
      )}
      {showRequestExtensionButton && (
        <div className="button-with-description">
          <span className="button-description">
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(drupalSettings.apt_config.screening_ext_description) }} />
          </span>
          <button
            className="full-width-button webform-button--submit button button--primary js-form-submit form-submit"
            onClick={onExtensionTrigger}
          >
            Request Screening Extension
          </button>
        </div>
      )}
      {showRequestHearingButton && (
        <div className="button-with-description">
          <span className="button-description">
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(drupalSettings.apt_config.hearing_description) }} />
          </span>
          <button
            className="full-width-button webform-button--submit button button--primary js-form-submit form-submit"
            onClick={onHearingTrigger}
          >
            Request Hearing Review
          </button>
        </div>
      )}
      </div>
      )}
      <div className="button-wrapper"></div>
    </div>
  );
}
